/* ==========================================================================
   KINOVA — Premium sahifasi (Bosqich 13).

   Yagona vazifa: hisob raqamini bufer xotiraga nusxalash. To'lov ilovasida
   raqamni qo'lda ko'chirishda xato bo'lmasligi uchun.

   ⚠️ `navigator.clipboard` faqat HTTPS (yoki localhost) da ishlaydi —
      shuning uchun eski usul (`document.execCommand`) zaxira sifatida
      qoldirilgan. Ikkalasi ham ishlamasa, tugma matni o'zgarmaydi va
      foydalanuvchi raqamni qo'lda belgilab olishi mumkin (raqam har
      doim ekranda ko'rinib turadi).
   ========================================================================== */
(function () {
    'use strict';

    var btn = document.getElementById('copyAccountBtn');
    if (!btn) return;

    var account = btn.getAttribute('data-account') || '';
    var original = btn.innerHTML;

    function flash(text) {
        btn.textContent = text;
        setTimeout(function () { btn.innerHTML = original; }, 1800);
    }

    function legacyCopy(value) {
        var input = document.createElement('textarea');
        input.value = value;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();

        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) { ok = false; }

        document.body.removeChild(input);
        return ok;
    }

    btn.addEventListener('click', function () {
        if (!account) return;

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(account).then(
                function () { flash('Nusxalandi'); },
                function () { flash(legacyCopy(account) ? 'Nusxalandi' : 'Nusxalanmadi'); }
            );
            return;
        }

        flash(legacyCopy(account) ? 'Nusxalandi' : 'Nusxalanmadi');
    });
})();
